module.exports = {"522324001":"东观街道","522324002":"莲城街道","522324003":"三宝街道","522324004":"腾龙街道","522324101":"沙子镇","522324102":"碧痕镇","522324103":"大厂镇","522324104":"鸡场镇","522324105":"花贡镇","522324106":"中营镇","522324107":"光照镇","522324108":"茶马镇","522324200":"长流乡","522324204":"紫马乡","522324205":"安谷乡","522324206":"三宝彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522324.json
// module id = 2639
// module chunks = 0